import Skeleton from '@ahamove/web-components/lib/Skeleton';
import Stack from '@ahamove/web-components/lib/Stack';
import useIsMobile from '@/shared-hooks/useIsMobile';

export default function ListRecordSkeleton() {
  const isMobile = useIsMobile();

  return (
    <>
      {Array.from(Array(3).keys()).map((_, index) => {
        return (
          <Stack
            key={index}
            direction={isMobile ? 'column' : 'row'}
            height={isMobile ? 'auto' : 168}
            sx={{
              borderRadius: 4,
              boxShadow: '0px 10px 24px -5px rgba(15, 15, 15, 0.025)',
              p: 0,
            }}
          >
            <Skeleton
              width={isMobile ? '100%' : 263}
              height={168}
              variant="rectangular"
              sx={{
                borderTopLeftRadius: 16,
                borderBottomLeftRadius: isMobile ? 0 : 16,
                borderTopRightRadius: isMobile ? 16 : 0,
              }}
            />

            <Stack
              direction="column"
              flex={1}
              justifyContent="space-between"
              py={isMobile ? 2.5 : 2}
              px={isMobile ? 2.5 : 3}
            >
              <Stack direction="row" justifyContent="space-between" gap={1}>
                <Stack direction="column" gap={0.5}>
                  <Skeleton variant="rounded" width={200} height={32} />
                  <Skeleton variant="rounded" width={120} height={20} />
                </Stack>
                <Skeleton variant="rounded" width={100} height={24} />
              </Stack>
            </Stack>
          </Stack>
        );
      })}
    </>
  );
}
